// Face Club catalog of options for the Generator form.

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_prompt-poster-web/artifacts/vrzqswet_Face%20Club%20Logo2025%20transparent.png";

export const POSTER_TYPES = [
  "Auto (AI Cadang)",
  "Poster Kreatif",
  "Poster Komik",
  "Movie Poster",
  "Concert Poster",
  "Event Promotional",
  "Product Launch",
  "Fashion Editorial",
  "Travel Poster",
  "Food & Beverage",
  "Sports Event",
  "Music Album Cover",
  "Book Cover",
  "Festival Poster",
  "Political Campaign",
  "Real Estate",
  "Automotive",
  "Tech Conference",
  "Charity / NGO",
  "Religious / Spiritual",
  "Educational",
  "Corporate Branding",
  "Street Art",
  "Vintage Retro",
];

export const AI_MODELS = [
  { id: "auto", label: "Auto (AI Cadang)", provider: "Smart", note: "Sistem pilih ikut konteks" },
  { id: "gemini-3-flash-preview", label: "Gemini 3 Flash", provider: "Google", note: "Pantas, kreatif" },
  { id: "gpt-4o", label: "GPT-4o", provider: "OpenAI", note: "Seimbang" },
  { id: "gpt-5.2", label: "GPT-5.2", provider: "OpenAI", note: "Premium" },
  { id: "claude-sonnet-4-5-20250929", label: "Claude Sonnet 4.5", provider: "Anthropic", note: "Naratif tepat" },
];

// 6 creative selectors, 20 options each (+ Auto prepended).
export const SELECTORS = [
  {
    key: "style",
    label: "Gaya Visual",
    options: [
      "Auto",
      "Ultra Realistik",
      "Karikatur",
      "3D Cartoon",
      "Anime",
      "Comic Style",
      "Hyperrealistic",
      "Cinematic",
      "Minimalist",
      "Maximalist",
      "Art Deco",
      "Bauhaus",
      "Cyberpunk",
      "Noir",
      "Surreal",
      "Pop Art",
      "Vaporwave",
      "Brutalist",
      "Sketch / Line Art",
      "Watercolor",
      "Oil Painting",
      "Risograph",
      "Glitch / Datamosh",
      "Vintage 70s",
      "Y2K",
      "Editorial Magazine",
    ],
  },
  {
    key: "creative_elements",
    label: "Creative Elements",
    options: [
      "Auto (AI Cadang)",
      "Paper Cut",
      "Paper Sticker",
      "White Outline",
      "Scrapbook",
      "Travel Journal",
      "Layered Collage",
      "Magazine Cutout",
      "Newspaper Cutout",
      "Torn Paper",
      "Polaroid",
      "Film Strip",
      "Floating Photos",
      "Sticky Notes",
      "Masking Tape",
      "Washi Tape",
      "Paper Clip",
      "Binder Clip",
      "Push Pin",
      "Passport Stamp",
      "Postage Stamp",
      "Coffee Stain",
      "Paper Fold",
      "Paper Wrinkle",
      "Vintage Texture",
      "Printed Paper",
      "Canvas Texture",
      "Embossed Paper",
      "Debossed Paper",
      "Crumpled Paper",
    ],
  },
  {
    key: "frame_style",
    label: "Frame Style",
    options: [
      "Auto",
      "None",
      "Sticker",
      "White Outline",
      "Polaroid",
      "Torn Paper",
      "Magazine Frame",
      "Rounded Frame",
      "Film Strip",
      "Passport Frame",
      "Floating Card",
      "Vintage Border",
    ],
  },
  {
    key: "material_surface",
    label: "Material / Surface",
    options: [
      "Auto",
      "Kraft Paper",
      "Old Paper",
      "Canvas",
      "Wood",
      "Stone",
      "Concrete",
      "Glass",
      "Plastic",
      "Leather",
      "Marble",
      "Cardboard",
      "Glossy",
      "Matte",
      "Holographic",
      "Gold Foil",
      "Silver Foil",
    ],
  },
  {
    key: "props",
    label: "Props",
    options: [
      "Auto",
      "Flowers",
      "Coins",
      "Paper Clip",
      "Binder Clip",
      "Passport",
      "Travel Ticket",
      "Postcard",
      "Compass",
      "Vintage Camera",
      "Books",
      "Notebook",
      "Ribbon",
      "Wax Seal",
      "Envelope",
      "Map",
      "Glasses",
      "Pen",
      "Pencil",
      "Leaves",
      "Dry Flowers",
    ],
  },
  {
    key: "mood",
    label: "Mood / Suasana",
    options: [
      "Auto",
      "Dramatic",
      "Romantic",
      "Mysterious",
      "Energetic",
      "Calm",
      "Bold",
      "Playful",
      "Serious",
      "Nostalgic",
      "Futuristic",
      "Cozy",
      "Heroic",
      "Eerie",
      "Luxurious",
      "Raw / Gritty",
      "Dreamy",
      "Tense",
      "Joyful",
      "Solemn",
      "Empowering",
    ],
  },
  {
    key: "lighting",
    label: "Pencahayaan",
    options: [
      "Auto",
      "Golden Hour",
      "Blue Hour",
      "Hard Sunlight",
      "Soft Diffused",
      "Backlit / Rim",
      "Neon Glow",
      "Candlelight",
      "Studio Strobe",
      "Window Light",
      "Moonlight",
      "Volumetric Fog",
      "Spotlight",
      "Silhouette",
      "High Key",
      "Low Key",
      "Stage Lighting",
      "Mixed Color Gel",
      "Lens Flare",
      "Sunset Backlight",
      "Overcast",
    ],
  },
  {
    key: "composition",
    label: "Komposisi",
    options: [
      "Auto",
      "Centered",
      "Rule of Thirds",
      "Symmetrical",
      "Asymmetrical",
      "Close-up",
      "Wide Shot",
      "Bird's Eye",
      "Worm's Eye",
      "Dutch Angle",
      "Over-the-shoulder",
      "Foreground Frame",
      "Negative Space",
      "Diagonal",
      "Leading Lines",
      "Rule of Odds",
      "Layered Depth",
      "Tilt-Shift",
      "Panoramic",
      "Macro",
      "Split Composition",
    ],
  },
  {
    key: "palette",
    label: "Palet Warna",
    options: [
      "Auto",
      "Monochrome",
      "Black & Gold",
      "Pastel",
      "Warm Earth",
      "Cool Blue",
      "Forest Green",
      "Sunset Orange",
      "Neon Pop",
      "Muted Vintage",
      "High Contrast B/W",
      "Sepia",
      "Tropical",
      "Royal Purple",
      "Crimson & Cream",
      "Ocean Teal",
      "Charcoal & Amber",
      "Desert Sand",
      "Cyan / Magenta",
      "Rose Gold",
      "Custom",
    ],
  },
  {
    key: "shot_type",
    label: "Jenis Shot",
    options: [
      "Auto",
      "Extreme Close-up",
      "Close-up",
      "Medium Close-up",
      "Medium Shot",
      "Cowboy Shot",
      "Medium Wide",
      "Wide Shot",
      "Full Body",
      "Extreme Wide",
      "Establishing Shot",
      "Two-Shot",
      "Group Shot",
      "Over-the-shoulder",
      "POV (Point of View)",
      "Insert Shot",
      "Detail Shot",
      "Aerial Shot",
      "Tracking Shot",
      "Dolly Shot",
    ],
  },
  {
    key: "camera_angle",
    label: "Angle Kamera",
    options: [
      "Auto",
      "Eye Level",
      "High Angle",
      "Low Angle",
      "Dutch / Tilted Angle",
      "Bird's Eye / Top Down",
      "Worm's Eye",
      "Hip Level",
      "Knee Level",
      "Shoulder Level",
      "Ground Level",
      "Overhead",
      "Drone / Aerial",
      "Frontal",
      "Profile / Side",
      "3/4 Angle",
      "Back Shot",
      "Symmetrical Frontal",
      "Tilted Up",
      "Crane Shot",
    ],
  },
];

export const ORIENTATIONS = [
  { id: "portrait", label: "Portrait", w: 1080, h: 1920 },
  { id: "landscape", label: "Landscape", w: 1920, h: 1080 },
  { id: "square", label: "Square", w: 1080, h: 1080 },
  { id: "custom", label: "Custom", w: 0, h: 0 },
];

// Standard print/digital sizes — picking one populates width/height/unit.
// Marked as `id: "custom"` to reveal the manual width/height inputs.
export const STANDARD_SIZES = [
  { id: "auto",         label: "Auto (AI Cadang)",   w: 1080,  h: 1920,  unit: "px" },
  { id: "ig-square",    label: "Instagram Square",   w: 1080,  h: 1080,  unit: "px" },
  { id: "ig-portrait",  label: "Instagram Portrait", w: 1080,  h: 1350,  unit: "px" },
  { id: "ig-story",     label: "Story / Reels",      w: 1080,  h: 1920,  unit: "px" },
  { id: "fb-post",      label: "Facebook Post",      w: 1200,  h: 630,   unit: "px" },
  { id: "fb-cover",     label: "Facebook Cover",     w: 1640,  h: 924,   unit: "px" },
  { id: "twitter-post", label: "Twitter / X Post",   w: 1600,  h: 900,   unit: "px" },
  { id: "yt-thumb",     label: "YouTube Thumbnail",  w: 1280,  h: 720,   unit: "px" },
  { id: "yt-banner",    label: "YouTube Banner",     w: 2560,  h: 1440,  unit: "px" },
  { id: "tiktok",       label: "TikTok 9:16",        w: 1080,  h: 1920,  unit: "px" },
  { id: "a4-portrait",  label: "A4 Portrait",        w: 21,    h: 29.7,  unit: "cm" },
  { id: "a4-landscape", label: "A4 Landscape",       w: 29.7,  h: 21,    unit: "cm" },
  { id: "a3-portrait",  label: "A3 Portrait",        w: 29.7,  h: 42,    unit: "cm" },
  { id: "a2-portrait",  label: "A2 Portrait",        w: 42,    h: 59.4,  unit: "cm" },
  { id: "a1-portrait",  label: "A1 Portrait",        w: 59.4,  h: 84.1,  unit: "cm" },
  { id: "letter",       label: "US Letter",          w: 8.5,   h: 11,    unit: "in" },
  { id: "tabloid",      label: "Tabloid",            w: 11,    h: 17,    unit: "in" },
  { id: "banner-3x6",   label: "Banner 3×6 ft",      w: 3,     h: 6,     unit: "ft" },
  { id: "banner-4x8",   label: "Banner 4×8 ft",      w: 4,     h: 8,     unit: "ft" },
  { id: "billboard",    label: "Billboard 10×20 ft", w: 10,    h: 20,    unit: "ft" },
  { id: "custom",       label: "Custom (Tetapan Sendiri)", w: 0, h: 0,    unit: "px" },
];

export const UNITS = ["px", "cm", "mm", "in", "ft"];

export const TIME_OF_DAY = [
  { id: "siang", label: "Siang", hint: "Bright daylight, vibrant" },
  { id: "pagi", label: "Pagi", hint: "Soft morning light" },
  { id: "petang", label: "Petang", hint: "Warm afternoon glow" },
  { id: "senja", label: "Senja", hint: "Golden / blue hour" },
  { id: "malam", label: "Malam", hint: "Night, neon / moonlight" },
  { id: "tengah-malam", label: "Tengah Malam", hint: "Midnight, deep dark" },
  { id: "auto", label: "Auto", hint: "AI decides" },
];

// Typography — font style presets for TITLE (headline) and BODY (isi/ucapan) text
export const TYPOGRAPHY_STYLES = [
  { id: "auto", label: "Auto (AI Cadang)" },
  { id: "serif-modern", label: "Serif Modern", hint: "Contemporary serif, e.g. Playfair" },
  { id: "serif-classic", label: "Serif Klasik", hint: "Traditional editorial serif" },
  { id: "sans-modern", label: "Sans Modern", hint: "Clean geometric sans" },
  { id: "sans-bold", label: "Sans Bold", hint: "Heavy poster-weight sans" },
  { id: "display", label: "Display Poster", hint: "Oversized display face" },
  { id: "condensed", label: "Condensed", hint: "Tall narrow letters" },
  { id: "handwritten", label: "Handwritten", hint: "Casual hand-drawn script" },
  { id: "brush-script", label: "Brush Script", hint: "Painted brush lettering" },
  { id: "calligraphy", label: "Calligraphy", hint: "Elegant flowing calligraphic" },
  { id: "monospace", label: "Monospace", hint: "Technical typewriter feel" },
  { id: "art-deco", label: "Art Deco", hint: "1920s geometric" },
  { id: "retro-70s", label: "Retro 70s", hint: "Groovy vintage type" },
  { id: "vaporwave", label: "Vaporwave", hint: "Neon 80s stylised" },
  { id: "arabic-jawi", label: "Arabic / Jawi", hint: "Islamic calligraphic feel" },
  { id: "graffiti", label: "Graffiti", hint: "Urban spray-paint style" },
  { id: "grunge", label: "Grunge", hint: "Distressed textured type" },
  { id: "minimalist", label: "Minimalist", hint: "Thin, airy, refined" },
  { id: "3d-extruded", label: "3D Extruded", hint: "Deep dimensional type" },
  { id: "chrome-metallic", label: "Chrome / Metalik", hint: "Reflective metallic finish" },
  { id: "neon-glow", label: "Neon Glow", hint: "Glowing tube-light letters" },
  { id: "paper-cut", label: "Paper Cut", hint: "Cut-out paper letters with shadow" },
  { id: "sticker-typography", label: "Sticker Typography", hint: "Sticker-style with white outline" },
  { id: "embossed", label: "Embossed", hint: "Raised, pressed-out letters" },
  { id: "debossed", label: "Debossed", hint: "Pressed-in, indented letters" },
  { id: "letterpress", label: "Letterpress", hint: "Vintage printing press impression" },
  { id: "foil-typography", label: "Foil Typography", hint: "Metallic foil-stamped letters" },
  { id: "vintage-print", label: "Vintage Print", hint: "Old printed magazine feel" },
  { id: "magazine-title", label: "Magazine Title", hint: "Bold editorial masthead style" },
  { id: "newspaper", label: "Newspaper", hint: "Classic newspaper headline face" },
  { id: "rubber-stamp", label: "Rubber Stamp", hint: "Stamped ink imprint style" },
];

// ---- Reference-image per-image config ----
export const IMAGE_ROLES = [
  { id: "main_subject", label: "Subjek Utama" },
  { id: "product", label: "Produk Utama" },
  { id: "supporting", label: "Gambar Sokongan" },
  { id: "background", label: "Latar Belakang" },
  { id: "logo", label: "Logo" },
  { id: "decoration", label: "Elemen Dekorasi" },
  { id: "texture", label: "Tekstur / Material" },
  { id: "style_reference", label: "Rujukan Gaya" },
];

export const IMAGE_POSITIONS = [
  { id: "auto", label: "Auto" },
  { id: "center", label: "Tengah" },
  { id: "top-left", label: "Atas Kiri" },
  { id: "top-right", label: "Atas Kanan" },
  { id: "middle-left", label: "Tengah Kiri" },
  { id: "middle-right", label: "Tengah Kanan" },
  { id: "bottom-left", label: "Bawah Kiri" },
  { id: "bottom-right", label: "Bawah Kanan" },
  { id: "full-background", label: "Latar Penuh" },
  { id: "foreground", label: "Foreground" },
];

export const IMAGE_DISPLAY_SIZES = [
  { id: "small", label: "Kecil" },
  { id: "medium", label: "Sederhana" },
  { id: "large", label: "Besar" },
  { id: "hero", label: "Hero / Dominan" },
  { id: "full-bleed", label: "Full Bleed" },
];

export const IMAGE_TREATMENTS = [
  { id: "keep-original", label: "Kekalkan 100% Asal" },
  { id: "remove-bg", label: "Buang Latar Belakang" },
  { id: "sticker-cutout", label: "Potongan Sticker" },
  { id: "white-outline", label: "Outline Putih" },
  { id: "polaroid-frame", label: "Frame Polaroid" },
  { id: "torn-paper-frame", label: "Frame Kertas Koyak" },
  { id: "paper-cutout", label: "Paper Cut-out" },
  { id: "realistic-shadow", label: "Bayang Realistik" },
  { id: "3d-popout", label: "Efek 3D Pop-out" },
  { id: "blend-background", label: "Blend Dengan Latar" },
  { id: "monochrome", label: "Monokrom" },
  { id: "sepia", label: "Sepia Vintage" },
  { id: "glow", label: "Soft Glow" },
  { id: "cinematic-grade", label: "Cinematic Color Grade" },
  { id: "silhouette", label: "Jadikan Siluet" },
  { id: "halftone", label: "Jadikan Halftone" },
  { id: "illustration", label: "Jadikan Ilustrasi" },
  { id: "3d-cartoon", label: "Jadikan 3D Cartoon" },
  { id: "auto", label: "Auto (AI Cadang)" },
];

export const IMAGE_PRESERVATION = [
  { id: "flexible", label: "Fleksibel — AI boleh stylize" },
  { id: "identity", label: "Kekalkan Identiti" },
  { id: "face-clothing", label: "Kekalkan Wajah & Pakaian" },
  { id: "product-label", label: "Kekalkan Produk & Label" },
  { id: "exact", label: "Kekalkan 100% Gambar Asal" },
];
